<template>
  <div>
    <h2 class="text-center">Contact the Presenter</h2>
    <form id="contact_form" @submit.prevent="submitForm()" v-if="submitted === false">
      <div class="form-group">
        <label for="name">Your name:*</label>
        <input v-model="name" class="form-control" id="name" name="name" required type="text" autocomplete="false"/>
      </div>
      <div class="form-group">
        <label for="email">Your email:*</label>
        <input v-model="email" class="form-control" id="email" name="email" required type="email" autocomplete="false"/>
      </div>
      <div class="alert alert-danger h5 fw-bold" v-if="checkMail()">
        This email domain is not allowed.
      </div>
      <div class="form-group">
        <label for="message">Message:*
          <small>(<span>{{ message.length }}</span> / <span>{{ maxLength }}</span>)</small>
        </label>
        <textarea v-model="message" class="form-control" name="message" id="message" required
                  :maxlength="maxLength"></textarea>
      </div>
      <div class="form-group">
        <input class="" id="datasecurity" name="datasecurity" required type="checkbox"/> I accept the Data Security
        Agreement <span class="pointer-click" v-on:click="showDSGVO = !showDSGVO">(Click here to see the complete Data Security Agreement.)</span>
      </div>
      <div class="row" v-if="showDSGVO">
        <div class="col">
          <iframe src="https://www.abstractstosubmit.com/datenschutz/eposter_wall/data_security_agreement.html"
                  class="w-100 h-100">
          </iframe>
        </div>
      </div>
      <br>
      <button type="submit" class="btn btn-primary w-100 mb-3" data-bs-dismiss="modal" v-if="checkMail() === false">
        <icon :icon="['fad', 'paper-plane']" v-on:submit="sendMail()"/>
        Send
      </button>
      <div class="row alert border-info">
        <div class="col col-1">
          <icon :icon="['fad', 'info']" class="fa-2x"/>
        </div>
        <div class="col col-10 offset-1 my-auto">All data entered will be transmitted to the presenter by
          e-mail.<br>You will receive a copy.
        </div>
      </div>
    </form>

    <div v-if="submitted === true">
      <div class="row alert alert-success">
        <div class="col col-2">
          <icon :icon="['fad', 'check-circle']" class="fa-5x"/>
        </div>
        <div class="col my-auto">Your e-mail has been sent to the presenter.<br> We can not guarantee
          that
          this e-mail
          will
          be delivered or read.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState, mapActions, mapMutations, mapGetters} from 'vuex'

export default {
  name: "Mail",
  data: function () {
    return {
      submitted: false,
      name: '',   // data for the name on the form
      email: '',   // data for the email on the form
      message: '', // data for the message on the form
      maxLength: 2500, // maximum length of the form message
      posterID: this.$store.state.contactPoster,
      errorMessage: '',// message to show the user if there is an error
      showDSGVO: false,
      showFromError: false
    }
  },
  computed: {
    ...mapState(['setting']),
  },
  methods: {
    ...mapMutations(['setContactPoster']),
    genericMessage() {
      return process.env.VUE_APP_MAILHEADER;
    },
    getBackUrl() {
      return '/view/' + this.$route.params.id;
    },
    checkMail() {
      if (this.email && this.setting.contact_from_blacklist.length > 0) {
        const emailDomain = this.email.split('@')[1];
        if (this.setting.contact_from_blacklist.includes(emailDomain)) {
          // If the email domain is in the blacklist, cancel the submission and show an error message
          return true;
        }
      }
      return false;
    },
    submitForm() {
      if (this.checkMail()) {
        this.setContactPoster(null);
        return;
      }
      let mail = {
        'abstract_id': this.$store.state.contactPoster,
        'name': this.name,
        'email': this.email,
        'message': this.message,
        'generic_message': this.genericMessage()
      };
      this.$store.dispatch('TRACK_ACTION', {'value': this.$store.state.contactPoster, 'action': 'mail/contact', 'source': process.env.VUE_APP_GOOGLE_ANALYTICS_NAME});
      this.$store.dispatch('SEND_MAIL_CONTACT', mail);
      this.submitted = true;
      this.setContactPoster(null);
    }
  },
}
</script>

<style scoped>

</style>
